@if (isHeaderReady()) {
  @if (isStudyHeader()) {
    <header class="study-header">
      <div class="study-header__inner">
        <div class="study-header__brand">
          <a class="study-header__logo" [routerLink]="appPaths.STUDY" aria-label="Home">
            <img src="/assets/images/dummy-logo.png" class="img-fluid" alt="Logo" />
            <div class="study-header__brand-copy">
              <span class="study-header__brand-title">Participants Enrollment</span>
            </div>
          </a>
        </div>

        @if (isSuperAdmin()) {
          <nav class="study-header__nav" aria-label="Admin">
            <a
              class="study-header__nav-link"
              [routerLink]="appPaths.STUDY"
              [class.active]="isStudyNavActive()"
            >
              <img src="/assets/icons/form.png" alt="" />
              <span>Choose a Study</span>
            </a>
            <a
              class="study-header__nav-link"
              [routerLink]="appPaths.USERS"
              [class.active]="isActive(appPaths.USERS)"
            >
              <img src="/assets/icons/roles.png" alt="" />
              <span>User</span>
            </a>
          </nav>
        }

        <div class="study-header__aside">
          <!-- Avatar + name open the account menu, so users without a study can still reach
               Profile / Change Password / Logout from the study screens -->
          <div class="user-menu">
            <button
              type="button"
              class="study-header__user-trigger"
              (click)="toggleDropdown($event)"
              [attr.aria-expanded]="dropdownOpen()"
              aria-label="Account menu"
            >
              <div class="study-header__meta">
                <h5 class="m-0 header-text">{{ currentUserName() }}</h5>
                @if (currentRoleName()) {
                  <small class="role-chip">{{ currentRoleName() }}</small>
                }
              </div>
              <img [src]="profilePath()" (error)="setDefaultImage($event)" class="study-header-user-image" alt="" />
            </button>

            @if (dropdownOpen()) {
              <div class="header-menu-panel header-menu-panel--right header-menu-panel--user">
                <ng-container [ngTemplateOutlet]="userMenuItems" />
              </div>
            }
          </div>
        </div>
      </div>
    </header>
  } @else {
    <header class="app-header">
      <div class="app-header__inner">
        <div class="app-header__brand">
          <a class="logo" [routerLink]="'/dashboard'" aria-label="Home">
            <img src="/assets/images/dummy-logo.png" class="img-fluid" alt="Logo" />
            <div class="brand-copy">
              <span class="brand-title">Participants Enrollment</span>
            </div>
          </a>

          <button
            type="button"
            class="nav-toggle"
            (click)="toggleCollapse()"
            [attr.aria-expanded]="!isCollapsed()"
            aria-label="Toggle navigation"
          >
            <span class="material-symbols-outlined">{{ isCollapsed() ? 'menu' : 'close' }}</span>
          </button>
        </div>

        <nav #navEl class="app-nav" [class.app-nav--open]="!isCollapsed()" aria-label="Main">
          <ul class="app-nav__list">
            @for (menuitem of primaryMenu(); track menuitem.menuUrl) {
              <li>
                <a
                  class="app-nav__link"
                  [routerLink]="menuitem.menuUrl"
                  [class.active]="isActive(menuitem.menuUrl)"
                >
                  <img [src]="menuitem.menuIcon" [alt]="" />
                  <span>{{ menuitem.menuName }}</span>
                </a>
              </li>
            }
          </ul>

          @if (moreMenu().length) {
            <div class="app-nav__more">
              <button
                type="button"
                class="app-nav__link app-nav__more-btn"
                [class.active]="isMoreActive() || moreOpen()"
                (click)="toggleMore($event)"
                [attr.aria-expanded]="moreOpen()"
              >
                <span class="material-symbols-outlined more-icon">more_horiz</span>
                <span>More</span>
                <span class="material-symbols-outlined chevron">expand_more</span>
              </button>

              @if (moreOpen()) {
                <div class="header-menu-panel">
                  @for (menuitem of moreMenu(); track menuitem.menuUrl) {
                    <a
                      class="header-menu-panel__item"
                      [routerLink]="menuitem.menuUrl"
                      [class.active]="isActive(menuitem.menuUrl)"
                      (click)="closeMore()"
                    >
                      <img [src]="menuitem.menuIcon" [alt]="" />
                      <span>{{ menuitem.menuName }}</span>
                    </a>
                  }
                </div>
              }
            </div>
          }

          <!-- Off-screen measure row: used to decide width-based overflow into More -->
          <ul #measureEl class="app-nav__measure" aria-hidden="true">
            @for (menuitem of menus(); track menuitem.menuUrl) {
              <li data-menu-measure>
                <span class="app-nav__link">
                  <img [src]="menuitem.menuIcon" [alt]="" (load)="onMeasureImageLoad()" (error)="onMeasureImageLoad()" />
                  <span>{{ menuitem.menuName }}</span>
                </span>
              </li>
            }
            <li #moreMeasureEl>
              <span class="app-nav__link app-nav__more-btn">
                <span class="material-symbols-outlined more-icon">more_horiz</span>
                <span>More</span>
                <span class="material-symbols-outlined chevron">expand_more</span>
              </span>
            </li>
          </ul>
        </nav>

        <div class="app-header__aside">
          @if (currentStudyName()) {
            <div class="study-chip" title="{{ currentStudyName() }}">
              <span class="study-chip__label">Study:</span>
              <span class="study-chip__name">{{ currentStudyName() }}</span>
            </div>
            <div class="header-divider"></div>
          }

          <div class="user-menu">
            <button
              type="button"
              class="user-menu__trigger"
              (click)="toggleDropdown($event)"
              [attr.aria-expanded]="dropdownOpen()"
            >
              <div class="user-meta">
                <span class="user-meta__name">{{ currentUserName() }}</span>
                @if (currentRoleName()) {
                  <span class="role-chip">{{ currentRoleName() }}</span>
                }
              </div>
              <img [src]="profilePath()" (error)="setDefaultImage($event)" class="user-image" alt="User" />
            </button>

            @if (dropdownOpen()) {
              <div class="header-menu-panel header-menu-panel--right header-menu-panel--user">
                <ng-container [ngTemplateOutlet]="userMenuItems" />
              </div>
            }
          </div>
        </div>
      </div>
    </header>
  }
}

<!-- Account menu items — shared by the study header and the main app header -->
<ng-template #userMenuItems>
  <button type="button" class="header-menu-panel__item" (click)="openProfile()">
    <span class="material-symbols-outlined">person</span>
    Profile
  </button>
  @if (hasSelectedStudy()) {
    <button type="button" class="header-menu-panel__item" (click)="switchStudy()">
      <span class="material-symbols-outlined">swap_horiz</span>
      Switch Study
    </button>
  }
  <button type="button" class="header-menu-panel__item" (click)="openChangePassword()">
    <span class="material-symbols-outlined">lock_reset</span>
    Change Password
  </button>

  <div class="header-menu-panel__divider" role="separator"></div>

  <button type="button" class="header-menu-panel__item header-menu-panel__item--danger" (click)="logout()">
    <span class="material-symbols-outlined">logout</span>
    Logout
  </button>
</ng-template>

@if (showProfileModal()) {
  <div class="sidebar-modal-backdrop" (click)="closeProfileModal()">
    <div class="sidebar-modal" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <app-my-profile
          [userId]="currentUserId()"
          (profileModalEvent)="closeProfileModal()"
          (nameUpdated)="updateHeaderName()"
        ></app-my-profile>
      </div>
    </div>
  </div>
}

<!-- No close on backdrop click: an accidental click outside would lose the typed passwords / OTP step -->
@if (showChangePasswordModal()) {
  <!-- Hidden (kept alive) while the OTP dialog is open, so "Back to Change Password" restores the typed values -->
  <div class="sidebar-modal-backdrop" [class.d-none]="changePasswordOtpOpen()">
    <div class="sidebar-modal" role="dialog" aria-modal="true" aria-labelledby="change-password-modal-title">
      <div class="modal-content">
        <app-change-password
          (closed)="closeChangePasswordModal()"
          (otpOpenChange)="changePasswordOtpOpen.set($event)"
        ></app-change-password>
      </div>
    </div>
  </div>
}
